import React, { useState, useEffect } from 'react';
import styled from 'styled-components'

import TabContainer from '../TabContainer'

import List from './list/List'
import ModalDelete from '../ModalDelete';
import { listCustomGroupApi, deleteCustomGroupOfCompany, resetPoiApi } from '../../api/customGroupApi';
import CustomGroup from "./CustomGroup/CustomGroup"

const UsersAdministration = ({ height, company }) => {

  const [customGroupsList, setCustomGroupsList] = useState([])
  const [customGroupSelected, setCustomGroupSelected] = useState(null);
  const [customGroupToRemove, setCustomGroupToRemove] = useState(null);


  useEffect(() => {
    if (company.id) {
      console.log('reloadList')
      reloadCustomGroupList()
    }
  }, [company.id])

  // useEffect(() => {
  //   console.log(customGroupsList)
  // }, [customGroupsList])

  const reloadCustomGroupList = () => {
    listCustomGroupApi(company.id)
      .then(response => {
        setCustomGroupsList(response.data);
      })
  }

  const selectCustomGroup = (customGroup) => {
    setCustomGroupSelected(customGroup);
  };

  const newCustomGroup = () => {
    setCustomGroupSelected({})
  }

  const deleteCustomGroup = (customGroupId) => {
    console.log(customGroupId)
    deleteCustomGroupOfCompany(customGroupId)
      .then((response) => {
        setCustomGroupToRemove(null);
        setCustomGroupsList(customGroupsList.filter(customGroupsList => customGroupsList.id !== customGroupId));
        resetPoiApi(response.data)
      })
      .catch(error => {
        console.error('ERROR: ', error);
      });
  }

  const openModalDeleteCustomGroup = (customGroup) => {
    setCustomGroupToRemove(customGroup);
  }


  return (
    <TabContainer height={height}>
      <AdmMainContainer>

        <ModalDelete
          show={customGroupToRemove != null}
          text={`Are you sure do you want remove the user ${customGroupToRemove?.name.toUpperCase()}?`}
          cancel={() => setCustomGroupToRemove(null)}
          remove={() => deleteCustomGroup(customGroupToRemove.id)}
        />

        {customGroupSelected ?
          <CustomGroup
            customGroup={customGroupSelected}
            company={company}
            selectCustomGroup={selectCustomGroup}
            reloadCustomGroupList={reloadCustomGroupList}
          />
          :
          <List
            items={customGroupsList}
            selectCustomGroup={selectCustomGroup}
            deleteCustomGroup={openModalDeleteCustomGroup}
            newCustomGroup={newCustomGroup} />
        }
      </AdmMainContainer>
    </TabContainer>
  )


}

const AdmMainContainer = styled.div`
    display:flex;
    
    /* border:5px solid yellow; */

`

export default UsersAdministration;